<div class="container flex column" *ngIf="vm">
  <div class="flex header row align-items-center">
    <div class="preset-name">
      <h3
        #editableName
        contenteditable="true"
        (focus)="editableName.textContent = vm.name"
        (input)="vm.name = editableName.textContent"
        (blur)="vm.onBroadcastPresetNameEdited()"
        (keydown.enter)="$event.preventDefault()"
        (paste)="vm.handleContentEditablePaste($event, 'name')"
      >
        {{ vm.name }}
      </h3>
    </div>
    <div
      class="status"
      *ngIf="showStatus"
      [ngClass]="{ edit: !vm.allowLiveMode, live: vm.allowLiveMode }"
      [title]="
        vm.allowLiveMode
          ? 'broadcast preset is in LIVE mode'
          : 'broadcast preset is in EDIT mode'
      "
    >
      {{ vm.allowLiveMode ? "LIVE" : "EDIT" }}
    </div>
    <div class="duplicate-button" [hidden]="true">
      <evrideo-copy-button
        class="copy-button"
        [hoverClass]="'black'"
        title="Make A Copy"
        (click)="vm.onDuplicateClicked()"
      ></evrideo-copy-button>
    </div>
    <div class="settings-button" [hidden]="true">
      <settings-button
        data-title="EDIT"
        title="Settings"
        [hoverClass]="'hover-black'"
      ></settings-button>
    </div>
  </div>
  <div class="previews" [ngClass]="{ 'mam-collapsed': mamCollapsed }">
    <div class="preview-video flex column">
      <div class="flex row preview-header space-between">
        <div class="label">PREVIEW</div>
        <div
          class="label"
          *ngIf="
            vm.debugMode && vm.previewWindowData && vm.previewWindowData.status
          "
        >
          {{ vm.previewWindowData.status }}
        </div>
        <div
          class="head-phone"
          *ngIf="vm.previewWindowData"
          (click)="vm.turnOnAudio(vm.previewWindowData)"
        >
          <evrideo-head-phone
            [overrideStyle]="{ scale: '1.4', fill: 'white' }"
            [disabled]="vm.previewWindowData?.isMuted"
            class="cursor-pointer"
          ></evrideo-head-phone>
        </div>
      </div>
      <div class="flex row video">
        <video
          #previewVideoElement
          *ngIf="vm.previewWindowData"
          autoplay
          width="100%"
          height="100%"
          [poster]="'/assets/stream-preview-loader.gif'"
          [webrtc-src]="vm.previewWindowData"
          [muted]="vm.previewWindowData.isMuted"
          (playing)="vm.onVideoStartedToPlay($event, vm.previewWindowData)"
          (onConnectionStateChanged)="
            vm.onVideoConnectionStateChanged(vm.previewWindowData, $event)
          "
          [attr.controls]="
            vm.previewWindowData.showVideoControls == false ? null : true
          "
          (window:resize)="vm.adjustAspectRatio(previewVideoElement, 16 / 9)"
          (loadedmetadata)="vm.adjustAspectRatio(previewVideoElement, 16 / 9)"
        ></video>
      </div>
    </div>
    <div class="program-video flex column">
      <div class="flex row preview-header space-between">
        <div class="label">PROGRAM</div>
        <div
          class="label"
          *ngIf="
            vm.debugMode && vm.programWindowData && vm.programWindowData.status
          "
        >
          {{ vm.programWindowData.status }}
        </div>
        <div
          class="head-phone"
          *ngIf="vm.programWindowData"
          (click)="vm.turnOnAudio(vm.programWindowData)"
        >
          <evrideo-head-phone
            [overrideStyle]="{ scale: '1.4', fill: 'white' }"
            [disabled]="vm.programWindowData?.isMuted"
            class="cursor-pointer"
          ></evrideo-head-phone>
        </div>
      </div>
      <div class="flex row video">
        <video
          #programVideoElement
          *ngIf="vm.programWindowData"
          autoplay
          width="100%"
          height="100%"
          [poster]="'/assets/stream-preview-loader.gif'"
          [muted]="vm.programWindowData.isMuted"
          [webrtc-src]="vm.programWindowData"
          (playing)="vm.onVideoStartedToPlay($event, vm.programWindowData)"
          (onConnectionStateChanged)="
            vm.onVideoConnectionStateChanged(vm.programWindowData, $event)
          "
          [attr.controls]="
            vm.programWindowData.showVideoControls == false ? null : true
          "
          (window:resize)="vm.adjustAspectRatio(programVideoElement, 16 / 9)"
          (loadedmetadata)="vm.adjustAspectRatio(programVideoElement, 16 / 9)"
        ></video>
      </div>
    </div>
    <evrideo-broadcast-editor-audio-mixer
      #audioMixerElement
      [broadcastPresetViewModel]="vm"
      [ngClass]="{ 'mam-collapsed': mamCollapsed }"
    ></evrideo-broadcast-editor-audio-mixer>
  </div>
  <div class="flex preview-actions row align-items-center space-between">
    <div class="broadcast-buttons flex row align-items-center justify-center">
      <div
        class="cut-button cursor-pointer button"
        *ngIf="vm.forceShowingCutButton || (vm.mode === 1 && vm.allowLiveMode)"
        (click)="vm.onCutClicked()"
      >
        CUT
      </div>
    </div>
    <div class="scheduler-buttons flex row align-items-center justify-end">
      <div class="flex row justify-center panel">
        <div class="divider"></div>
        <div
          class="start-live-button cursor-pointer button"
          *ngIf="vm.mode === 0 && vm.allowLiveMode"
          (click)="vm.onStartLiveClicked()"
        >
          START LIVE
        </div>
        <div
          class="start-live-button cursor-pointer button"
          *ngIf="vm.mode === 1 && vm.allowLiveMode"
          (click)="vm.onStopLiveClicked()"
        >
          STOP LIVE
        </div>
        <div class="divider"></div>
        <div
          class="scheduler-button cursor-pointer button"
          *ngIf="AllowDebugMode"
          (click)="vm.onSchedulerClickedEventHandler()"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 4C11.3 4 10.5 4.8 10.5 6H14.5C14.5 4.8 13.7 4 12.5 4ZM8.5 7C7.9 7 7.5 7.4 7.5 8V9.5H5V12H7.5V13.5H5V16H7.5V17.5C7.5 19.2 8.8 20.5 10.5 20.5H14.5C16.2 20.5 17.5 19.2 17.5 17.5V16H20V13.5H17.5V12H20V9.5H17.5V8C17.5 7.4 17.1 7 16.5 7H8.5ZM10.5 9H14.5V17.5H10.5V9ZM4 9.5V12H5V9.5H4ZM20 9.5V12H21V9.5H20ZM4 13.5V16H5V13.5H4ZM20 13.5V16H21V13.5H20Z"
              fill="#524e59"
              stroke="#524e59"
              stroke-width="0.1"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
  <div
    class="flex switch-panels column"
    [ngClass]="{ 'mam-collapsed': mamCollapsed }"
  >
    <div class="flex switcher-header row">
      <div
        class="flex switcher-button row"
        *ngFor="let switcher of vm.switchersVMs; let switcherIndex = index"
        [ngClass]="{
          selected: switcher === vm.selectedSwitcher,
          'cursor-pointer': !switcher.nameCanBeEdited,
        }"
        (click)="vm.toggleSwitch(switcher)"
      >
        <div class="switcher-index">{{ switcherIndex + 1 }}</div>
        <div class="divider"></div>
        <div
          #switcherNameElement
          class="switcher-name"
          title="{{ switcher.name }}"
          [ngClass]="{
            'text-overflow-ellipsis':
              switcher !== vm.selectedSwitcher && !switcher.nameCanBeEdited,
          }"
          [attr.contenteditable]="switcher.nameCanBeEdited"
          (dblclick)="switcher.onNameDoubleClicked($event)"
          (keydown.enter)="$event.preventDefault()"
          (paste)="switcher.handleContentEditablePaste($event, 'nameVM')"
          (focus)="switcherNameElement.textContent = switcher.name"
          (input)="switcher.name = switcherNameElement.textContent"
          (blur)="vm.onSwitcherNameEdited($event, switcher)"
        >
          {{
            switcher === vm.selectedSwitcher || switcher.nameCanBeEdited
              ? switcher.name
              : switcher.nameVM
          }}
        </div>

        <div
          class="switcher-x-button"
          [ngClass]="{ disabled: !vm.removeSwitchersEnabled }"
          (click)="
            vm.removeSwitchersEnabled &&
              vm.deleteSwitcherClicked($event, switcher)
          "
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M1.5 1.5L8.5 8.5M8.5 1.5L1.5 8.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
      <div
        class="switcher-add-button cursor-pointer"
        [ngClass]="{ disabled: !vm.addSwitchersEnabled }"
        (click)="vm.addSwitcherClicked()"
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 10.1113C17 10.6636 16.5523 11.1113 16 11.1113H11V16.1113C11 16.6636 10.5523 17.1113 10 17.1113C9.44772 17.1113 9 16.6636 9 16.1113V11.1113H4C3.44772 11.1113 3 10.6636 3 10.1113C3 9.55904 3.44772 9.11133 4 9.11133H9V4.11133C9 3.55904 9.44772 3.11133 10 3.11133C10.5523 3.11133 11 3.55904 11 4.11133V9.11133H16C16.5523 9.11133 17 9.55904 17 10.1113Z"
            fill="currentColor"
            opacity="0.6"
          />
        </svg>
      </div>
      <div
        class="resize-mode-toggle cursor-pointer"
        [ngClass]="{ active: resizeModeEnabled }"
        (click)="resizeModeEnabled = !resizeModeEnabled"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 3h7v2H5v5H3V3zm11 0h7v7h-2V5h-5V3zM3 14h2v5h5v2H3v-7zm16 5h-5v2h7v-7h-2v5z"
            fill="currentColor"
          />
        </svg>
        <span>RESIZE TILES</span>
      </div>
    </div>
    <div class="switcher-items">
      <div class="switcher-items-grid">
        <evrideo-switcher-item
          *ngFor="
            let switcherItem of vm.selectedSwitcher.itemsVMs;
            let itemIndex = index
          "
          [hidden]="vm.selectedSwitcher.isCovered(itemIndex)"
          [style.gridColumn]="vm.selectedSwitcher.getGridColumn(switcherItem)"
          [style.gridRow]="vm.selectedSwitcher.getGridRow(switcherItem)"
          [vm]="switcherItem"
          [switcherVm]="vm.selectedSwitcher"
          [broadcastPresetViewModel]="vm"
          [resizeModeEnabled]="resizeModeEnabled"
          (dragover)="$event.preventDefault()"
          (drop)="onSwitcherItemDrop($event, switcherItem)"
          title="{{ switcherItem.getTitle() }}"
        ></evrideo-switcher-item>
      </div>
    </div>
  </div>
  <div *ngIf="vm.debugMode" (click)="vm.onDebugWindowClicked()">
    <div class="debug-window">
      <div
        class="debug-window-header"
        (mousedown)="onDebugWindowDragHandleMouseDown($event)"
      >
        <h1>Debug</h1>
        <button (click)="vm.onSchedulerClickedEventHandler()">close</button>
      </div>
      <fieldset>
        <legend><b>PREVIEW</b></legend>
        <div class="flex column">
          <button (click)="vm.createWebrtcChannel(false)">
            Create WebRTCChannel
          </button>
          <button (click)="vm.sendEmptyPlaylist(vm.previewWindowData)">
            Send Empty Playlist
          </button>
          <button (click)="vm.sendFullPlaylist(vm.previewWindowData)">
            Send Full Playlist
          </button>
          <button
            (click)="vm.sendPlaylistWithoutPrerolls(vm.previewWindowData)"
          >
            Send Playlist Without Prerolls
          </button>
          <button (click)="vm.invalidateCache(vm.previewWindowData)">
            Invalidate Cache
          </button>
          <button (click)="vm.getControllerCache(vm.previewWindowData)">
            Get Cache
          </button>
          <button (click)="vm.deactivateWebRTCChannel(vm.previewWindowData)">
            Deactivate WebRTCChannel
          </button>
        </div>
      </fieldset>
      <fieldset>
        <legend><b>PROGRAM</b></legend>
        <div class="flex column">
          <button (click)="vm.createWebrtcChannel(true)">
            Create WebRTCChannel
          </button>
          <button (click)="vm.sendEmptyPlaylist(vm.programWindowData)">
            Send Empty Playlist
          </button>
          <button (click)="vm.sendFullPlaylist(vm.programWindowData)">
            Send Full Playlist
          </button>
          <button
            (click)="vm.sendPlaylistWithoutPrerolls(vm.programWindowData)"
          >
            Send Playlist Without Prerolls
          </button>
          <button (click)="vm.invalidateCache(vm.programWindowData)">
            Invalidate Cache
          </button>
          <button (click)="vm.getControllerCache(vm.programWindowData)">
            Get Cache
          </button>
          <button (click)="vm.deactivateWebRTCChannel(vm.programWindowData)">
            Deactivate WebRTCChannel
          </button>
        </div>
      </fieldset>
      <fieldset>
        <legend><b>Miscellaneous</b></legend>
        <div class="flex column">
          <button (click)="vm.toggleCutButton()">
            <span
              [ngStyle]="
                vm.forceShowingCutButton === true && { 'font-weight': 'bold' }
              "
              >Toggle CUT Button</span
            >
          </button>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <b>LAST COMMAND {{ vm.lastCommandName }}</b>
        </legend>
        <p>Response:</p>
        <div class="flex column">
          <textarea [value]="vm.lastCommandResponse"></textarea>
          <b
            >Last Command Processing Time:
            {{ vm.lastCommandProcessingTimeMs }} milliseconds</b
          >
        </div>
      </fieldset>
    </div>
  </div>
</div>
